import React, { Component} from 'react'
import { observer } from 'mobx-react'

@observer
class TableFooter extends Component {    
    render() {
        const { day } = this.props

        return <div className="table__row table__row--footer">
            <div className="table__row__cell table__row__cell__icon table__row__cell__icon--hide"></div>
            <div className="table__row__cell table__row__cell--tiny"></div>
            <div className="table__row__cell"></div>
            <div className="table__row__cell"></div>
            <div className="table__row__cell table__row__cell--lg"></div>
            <div className="table__row__cell table__row__cell--md"></div>
            <div className="table__row__cell table__row__cell--right"></div>
            <div className="table__row__cell table__row__cell--right"></div>
            <div className="table__row__cell table__row__cell--right"></div>
            <div className="table__row__cell table__row__cell--sm table__row__cell--right">
                <span title="Total" className="table__header__list__cell__total">
                    { day.totalOrdersPerDay }
                </span>
            </div>
            <div className="table__row__cell table__row__cell--right">
                <span title="Total" className="table__list__cell__total">{ day.totalValuePerDay }</span>                
            </div>
            <div className="table__row__cell table__row__cell--right" title="Produktionstid">
                <span title="Total" className="table__list__cell__total">{ day.productionTotalTime }</span>                
            </div>
            <div className="table__row__cell table__row__cell--right" title="Resterande tid">
                <span title="Total" className="table__list__cell__total">{ day.totalRemainingTime }</span>                
            </div>
            <div className="table__row__cell table__row__cell--right"></div>
            <div className="table__row__cell table__row__cell--right">
                <span title="Total" className="table__list__cell__total">{ day.totalDayPercentile }%</span>                
            </div>
        </div>  
    }    
}

export default TableFooter
